<template>
  <div class="">
    <toptitle :title="topTitle" :subtitle="topSubTitle"></toptitle>
    <div class="products-container">
      <div class="container">
        <div class="row d-flex">
          <leftsidebar class="order-md-1 order-2"></leftsidebar>
          <div class="products-box col-md-9 order-md-2 order-1">
            <div class="row">
              <div class="col-12 article-container">
                <h3 class="article-title">{{model.title}}</h3>
                <div class="article-info">
                  <span class="article-info-date">发布时间：{{model.date}}</span>
                  <span class="article-info-category">文章分类：{{model.category.name}}</span>
                </div>
                <div class="article-content" v-html="model.body"></div>
                <hr>
                <router-link tag="a" to='/news' class="news-list">&lt;&lt; 返回新闻列表</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    id: { required: true }
  },
  data() {
    return {
      topTitle: '新闻中心',
      topSubTitle: '专业专注 · 用心服务',
      model: {}
    }
  },
  methods: {
    async fetch() {
      const res = await this.$http.get(`/news/${this.id}`)
      this.model = res.data
    }
  },
  created() {
    // this.fetch()
  }
}
</script>
<style scoped>
.products-container {
  padding: 30px 0;
}
.article-title {
  margin-top: 16px;
  line-height: 40px;
  font-size: 22px;
  color: #666;
  text-align: center;
}
.article-info {
  margin-top: 16px;
  color: #999;
  font-size: 16px;
  text-align: center;
}

.article-info-date {
  display: inline-block;
  padding-right: 30px;
}
.article-content {
  color: #666;
  font-size: 16px;
  margin: 30px 0;
  line-height: 36px;
}
.article-content p {
  margin-bottom: 10px;
}
hr {
  color: #f2f2f2;
}
.news-list {
  font-size: 16px;
  color: #048bd4;
  display: inline-block;
  margin-bottom: 30px;
}
</style>